/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a jumble of letters and instantly see every word you can make from them, sorted longest first — plus exact anagrams. Great for Scrabble, Words With Friends and crosswords.`)
};

const es_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una mezcla de letras y descubre al instante todas las palabras que puedes formar con ellas, ordenadas de más larga a más corta, además de los anagramas exactos. Ideal para Scrabble, Words With Friends y crucigramas.`)
};

const de_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib ein Buchstabendurcheinander ein und sieh sofort alle Wörter, die du daraus bilden kannst – sortiert nach Länge, längste zuerst –, sowie exakte Anagramme. Ideal für Scrabble, Words With Friends und Kreuzworträtsel.`)
};

const nl_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een reeks door elkaar gehusselde letters in en zie direct elk woord dat je ermee kunt maken, gesorteerd van langste naar kortste — plus exacte anagrammen. Ideaal voor Scrabble, Words With Friends en kruiswoordraadsels.`)
};

const fr_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un mélange de lettres et découvrez instantanément tous les mots que vous pouvez former, triés du plus long au plus court, ainsi que les anagrammes exacts. Idéal pour Scrabble, Words With Friends et les mots croisés.`)
};

const it_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un insieme disordinato di lettere e scopri all'istante ogni parola che puoi formare, ordinate dalla più lunga — più gli anagrammi esatti. Ideale per Scrabble, Words With Friends e cruciverba.`)
};

const pt_br2_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um conjunto de letras embaralhadas e veja instantaneamente todas as palavras que você pode formar com elas, ordenadas da mais longa para a mais curta — além dos anagramas exatos. Ótimo para Scrabble, Words With Friends e palavras cruzadas.`)
};

const pt_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um conjunto de letras baralhadas e veja instantaneamente todas as palavras que pode formar com elas, ordenadas da mais longa para a mais curta — além dos anagramas exatos. Ótimo para Scrabble, Words With Friends e palavras cruzadas.`)
};

const ja_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バラバラの文字を入力すると、それらから作れるすべての単語が長い順に瞬時に表示されます。完全一致のアナグラムも表示。Scrabble、Words With Friends、クロスワードに最適です。`)
};

const zh_wu_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入一堆打乱的字母，即可立即看到用它们能拼出的所有单词，按最长优先排序——同时显示完全匹配的易位构词。非常适合 Scrabble、Words With Friends 和填字游戏。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_intro", locale)
	if (locale === "en") return en_wu_hub_intro(inputs)
	if (locale === "es") return es_wu_hub_intro(inputs)
	if (locale === "de") return de_wu_hub_intro(inputs)
	if (locale === "nl") return nl_wu_hub_intro(inputs)
	if (locale === "fr") return fr_wu_hub_intro(inputs)
	if (locale === "it") return it_wu_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_intro(inputs)
	if (locale === "pt") return pt_wu_hub_intro(inputs)
	if (locale === "ja") return ja_wu_hub_intro(inputs)
	return zh_wu_hub_intro(inputs)
};